// 方案二：深绿色系 - 成长、发展、专业
// 适合：职业发展平台，传达成长和发展的理念
export const professionalGreenTheme = {
  colors: {
    'psychology-primary': '#059669',      // 深绿色 - 成长、发展、专业
    'psychology-secondary': '#047857',    // 更深绿色 - 辅助色，稳重
    'psychology-accent': '#10B981',       // 亮绿色 - 强调色，活力
    'psychology-calm': '#ECFDF5',         // 极浅绿色 - 背景色，清新
    'psychology-warm': '#D1FAE5',         // 浅绿色 - 温暖背景
    'psychology-success': '#10B981',      // 绿色 - 成功、积极
    'psychology-info': '#0891B2',         // 青色 - 信息状态
    'psychology-warning': '#F59E0B',      // 橙色 - 警告状态
  },
  name: 'professional-green',
  description: '深绿色系主题 - 成长、发展、专业，适合职业发展平台'
}

